export const hotspots = [
  {
    location: [11.53, 30],
    caption:
      'Large 1,100 sq.ft. fitness room and yoga studio for strenghening body and mind',
  },
  {
    location: [15.83, 58.75],
    caption: '',
  },
  {
    location: [32.81, 26.75],
    caption: '',
  },
  {
    location: [31.6, 71.75],
    caption: '',
  },
  {
    location: [66, 43.13],
    caption: '',
  },
  {
    location: [75.01, 59.75],
    caption: '',
  },
];

export const features = [
  'Fitness Room',
  'Office',
  'Yoga Studio',
  'Private Music Room',
  'Work Station',
  'Mail',
  'Teamwork Room',
  'Canada Post',
  'Study',
  'Club Room',
  'Music Room',
  'Lobby',
  'Concierge',
  'Library',
];



// WEBPACK FOOTER //
// ./src/data/sitemap.js